import { Injectable } from '@angular/core';
import { MultiLanguageService } from '@share/translate';
import { LoginAlertComponent } from '@share/components/login-alert/login-alert.component';
import { OverlayService } from '@core/components/overlay/overlay.service';
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root',
})
export class UtilService {
  constructor(
    private _snackBar: MatSnackBar,
    private readonly translate: MultiLanguageService,
    private readonly overlayService: OverlayService
  ) {}


  openSnackBar(msg: string) {
    var okText = this.translate.instant(
      "Ok");

    this._snackBar.open(msg, okText, {
      horizontalPosition: this.translate.currentLanguage()=='en'?'start':'end',
      verticalPosition: 'top',
      panelClass: 'snack-bar-custom',
    });
  }
  openGuestAlert(): void {
    this.overlayService.open(LoginAlertComponent, { showGuestBtn: false });
  }
}
